import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _omitBy from 'lodash/omitBy';

import sdk from '@medipass/web-sdk';
export const updateMembersHealthFundAccount = async ({
  healthFundAccount,
  isCreate,
  memberId,
}: {
  healthFundAccount: Record<string, any>;
  isCreate?: boolean;
  memberId: string;
}) => {
  let body = {};

  if (healthFundAccount && healthFundAccount.healthFundId) {
    const expiryDateArray = _get(healthFundAccount, 'expiryDate', '').split('/');

    const issueDateArray = _get(healthFundAccount, 'issueDate', '').split('/');

    body = _omitBy(
      {
        cardIssueNumber: healthFundAccount.cardIssueNumber,
        cardNumber: healthFundAccount.cardNumber,
        cardRank: healthFundAccount.cardRank,
        healthFundId: healthFundAccount.healthFundId,
        expiryDay: _get(expiryDateArray, '[0]'),
        expiryMonth: _get(expiryDateArray, `[${expiryDateArray.length - 2}]`),
        expiryYear: _get(expiryDateArray, `[${expiryDateArray.length - 1}]`),
        issueDay: _get(issueDateArray, '[0]'),
        issueMonth: _get(issueDateArray, `[${issueDateArray.length - 2}]`),
        issueYear: _get(issueDateArray, `[${issueDateArray.length - 1}]`),
        membershipNumber: healthFundAccount.membershipNumber,
      },
      _isEmpty,
    );

    if (healthFundAccount.healthFundAccountId && !isCreate) {
      await sdk.healthFundAccounts.updateMembersHealthFundAccounts(
        memberId,
        healthFundAccount.healthFundAccountId,
        body,
      );
    } else {
      await sdk.healthFundAccounts.createMembersHealthFundAccount(memberId, body);
    }
  }

  return body;
};
